import { formatNumberWithCommas } from '@/utils/functions/math/formatNumberWithCommas'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { availableLanguages, fallbackLng } from './resources'

// eslint-disable-next-line import-x/no-named-as-default-member
const instance = i18next.use(HttpBackend).use(LanguageDetector).use(initReactI18next)

await instance.init({
  fallbackLng,
  supportedLngs: [...availableLanguages],
  debug: import.meta.env.DEV,
  load: 'currentOnly',
  backend: {
    loadPath: `/locales/translations/{{lng}}.json?v=${__BUILD_VERSION__}`,
    addPath: `/locales/translations/add/{{lng}}.json?v=${__BUILD_VERSION__}`,
  },
  interpolation: {
    escapeValue: false,
    format: (value, format) => {
      if (format === 'number') return formatNumberWithCommas(value)
      return value
    },
  },
})

export default instance
